const skillSets = [
  "Rust",
  "Solidity",
  "Golang",
  "TypeScript",
  "JavaScript",
  "C/C++",
  "Python",
  "Solana",
  "EVM",
  "Bitcoin",
  "RWA",
  "DeFi",
  "AI",
  "React.Js",
  "Next.Js",
  "Node.Js",
  "Express",
  "PostgreSQL",
  "MongoDB",
  "MySQL",
  "Redis",
  "Firebase",
  "GraphQL",
  "Prisma",
  "Docker",
  "Kubernetes",
  "TailwindCSS"
];

const knowledgeSets = [
  "Devops",
  "Github",
  "Gitlab",
  "CI/CD Pipelline",
  "Design",
  "AWS",
  "Azure",
  "Agile Methodology",
];

export { skillSets, knowledgeSets };
